angular.module('picmonicng').factory('MarketDiscountModal', [
  '$modal',
  function ($modal) {
    return {
      show: function (id, type, market, promo, markets, onSave) {
        $modal.open({
          templateUrl: '/templates/app/factories/promo-code-modal/market-discount-modal.html',
          windowClass: 'market-discount-modal',
          size: 'lg',
          backdropClass: 'above-nav',
          backdrop: 'static',
          controller: [
            '$scope',
            'MathUtils',
            function ($scope, MathUtils) {
              initScopeProperties();
              initializeDiscountData();
              initializeDiscountSetters();
              initMarketConfig();
              initSubmitHandler();

              function initScopeProperties() {
                $scope.markets = markets;
                $scope.isAddDiscount = id === 'add';
                $scope.isDefaultMarket = type === 'default';
                $scope.headerLabel = getHeaderLabel();
                $scope.discountType = promo.discount_type;
                $scope.discountLengths = getDiscountLengths();
                $scope.discountByLength = [];
                $scope.bundleDiscountByLength = [];
              }

              function getHeaderLabel() {
                if ($scope.isAddDiscount) return 'Add Market Specific Discount';
                if ($scope.isDefaultMarket) return 'Edit Default Discount';
                return `Edit Market Specific Discount: ${market?.name || ''}`;
              }

              function getDiscountLengths() {
                return [
                  { id: 'monthly', label: 'Monthly', length: 1 },
                  { id: 'semesterly', label: 'Semesterly', length: 6 },
                  { id: 'annual', label: 'Annual', length: 12 },
                  { id: 'yearly', label: '24 Month', length: 24 },
                  { id: 'biyearly', label: '48 Month', length: 48 },
                ];
              }

              function initializeDiscountData() {
                const source = $scope.isDefaultMarket
                  ? {
                      discount: promo.discount_by_length,
                      bundle: promo.bundle_discount_by_length,
                    }
                  : {
                      discount: promo.market_standalone_discount_by_length?.[id],
                      bundle: promo.market_bundle_discount_by_length?.[id],
                    };

                $scope.discount_by_length = angular.copy(source.discount) || {};
                $scope.bundle_discount_by_length = angular.copy(source.bundle) || {};
              }

              function initializeDiscountSetters() {
                function createSetter(bundle, length) {
                  return function (discount) {
                    const field = bundle ? 'bundle_discount_by_length' : 'discount_by_length';
                    const isPercentDiscount = $scope.discountType === 1;
                    let value;
                    if (arguments.length) {
                      value = isPercentDiscount ? discount / 100 : discount;
                      $scope[field][length] = MathUtils.safeRound(value);
                    } else {
                      value = MathUtils.safeRound($scope[field][length]);
                    }

                    return MathUtils.safeRound(isPercentDiscount ? value * 100 : value);
                  };
                }

                $scope.discountLengths.forEach(({ length }) => {
                  $scope.discountByLength[length] = createSetter(false, length);
                  $scope.bundleDiscountByLength[length] = createSetter(true, length);
                });
              }

              function initMarketConfig() {
                $scope.marketConfig = {
                  selectedMarket: null,
                  taggedMarkets: market ? [market] : [],
                  addMarket: function (marketToAdd) {
                    if (!marketToAdd || this.taggedMarkets.some(m => m.id === marketToAdd.id)) return;
                    this.taggedMarkets.push(marketToAdd);
                    this.selectedMarket = null;
                  },
                  removeMarket: function (marketToRemove) {
                    const index = this.taggedMarkets.findIndex(m => m.id === marketToRemove.id);
                    if (index !== -1) this.taggedMarkets.splice(index, 1);
                  },
                  availableMarkets: function () {
                    return $scope.markets.filter(m => !this.taggedMarkets.some(tagged => tagged.id === m.id));
                  },
                };
              }

              function initSubmitHandler() {
                $scope.submit = function () {
                  onSave(prepareResult());
                  $scope.$close();
                };
              }

              function prepareResult() {
                if ($scope.isDefaultMarket) {
                  return {
                    discount_by_length: $scope.discount_by_length,
                    bundle_discount_by_length: $scope.bundle_discount_by_length,
                  };
                }

                const result = {
                  market_standalone_discount_by_length: { ...promo.market_standalone_discount_by_length },
                  market_bundle_discount_by_length: { ...promo.market_bundle_discount_by_length },
                };

                const targets = market ? [market] : $scope.marketConfig.taggedMarkets;
                targets.forEach(target => {
                  result.market_standalone_discount_by_length[target.id] = $scope.discount_by_length;
                  result.market_bundle_discount_by_length[target.id] = $scope.bundle_discount_by_length;
                });

                return result;
              }
            },
          ],
        });
      },
    };
  },
]);
